import {connect} from "react-redux";
import TeamDetails from "../Components/TeamDetails.jsx";
import {openHth} from "../../HeadToHead/headToHeadActions";

const mapStateToProps = (state) => {
    return {
        ownTeams: state.teamDetails.ownTeams,
        team: state.teamDetails.team,
        showHth: state.headToHead.show,
        game: state.games.current
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onHeadToHeadClick: team => dispatch(openHth(team))
    }
};

const TeamDetailsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TeamDetails);

export default TeamDetailsContainer